import React, { Component } from "react";
import { FiChevronDown, FiPlus } from "react-icons/fi";
import { HiPlus } from "react-icons/hi";
import { MdChevronLeft, MdClose } from "react-icons/md";
import NumberFormat from "react-number-format";
import { Redirect } from "react-router";
import SimpleHeader from "../../../base/features/blocks/SimpleHeader";
import moneyFormat from "../../../base/utils/moneyFormat";
import { apiService } from "../../../base/utils/service";
import CityModal from "./blocks/CityModal";
import MinCountModal from "./blocks/MinCountModal";
import MinPriceModal from "./blocks/MinPriceModal";

class PostingMethodDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: window.location.pathname.split("/")[4] === "add" ? "add" : "edit",
      shopUid: window.location.pathname.split("/")[2],
      methodUid: window.location.pathname.split("/")[4],
      shop: null,
      providers: null,
      name: "",
      des: "",
      index: 1,
      cityInput: "all",
      priceInput: "1",
      price: "",
      minPrice: "",
      minCount: "",
      freeByPrice: false,
      freeByCount: false,
      shopCity: false,
      pending: false,
      active: true,
      selectedProvider: null,
      cities: [],
      geoModal: false,
      selectedState: null,
      selectedCity: null,
    };
  }
  componentDidMount() {
    if (this.state.type === "add") {
      this.getProviders();
    } else {
      this.getMethod();
    }
  }

  getMethod() {
    apiService(
      `v1/shops/${this.state.shopUid}/shipping-configs/${this.state.methodUid}`
    ).then((data) => {
      if (data) {
        this.setState({
          providers: data.providers,
          shop: data.shop,
          active: data.active,
          des: data.des,
          price: data.price,
          index: data.index,
          shopCity: data.shop_city,
          name: data.title,
          cities: data.cities,
          minCount: data.free_min_count,
          freeByCount: data.free_min_count ? true : false,
          minPrice: data.free_min_purchase,
          freeByPrice: data.free_min_purchase ? true : false,
          selectedProvider: data.provider ? data.provider.uid : null,
          cityInput: data.all_city ? "all" : "one",
          priceInput: data.price === 0 ? "3" : data.price === null ? "2" : "1",
        });
      }
    });
  }
  getProviders() {
    apiService(`v1/shops/${this.state.shopUid}/shipping-configs/info`).then(
      (data) => {
        if (data) {
          this.setState({
            shop: data.shop,
            providers: data.providers,
            selectedProvider: data.providers[0].uid,
          });
        }
      }
    );
  }
  addMethod() {
    this.setState({ pending: true });
    let new_cities = [];
    this.state.cities.map((city, c) => {
      new_cities.push(city.uid);
    });
    let params = {
      title: this.state.name,
      des: this.state.des,
      price: this.state.price,
      free_min_purchase:
        this.state.minPrice && this.state.freeByPrice
          ? this.state.minPrice
          : null,
      free_min_count:
        this.state.minCount && this.state.freeByCount
          ? this.state.minCount
          : null,
      all_city: this.state.cityInput === "all" ? true : false,
      shop_city: this.state.shopCity,
      cities: new_cities,
      active: this.state.active,
      index: this.state.index,
      provider: this.state.selectedProvider,
    };
    apiService(
      `v1/shops/${this.state.shopUid}/shipping-configs`,
      "post",
      params
    ).then((data) => {
      if (data) {
        this.setState({ redirect: true });
      }
      this.setState({ pending: false });
    });
  }
  editMethod() {
    this.setState({ pending: true });
    let new_cities = [];
    this.state.cities.map((city, c) => {
      new_cities.push(city.uid);
    });
    let params = {
      title: this.state.name,
      des: this.state.des,
      price: this.state.price,
      free_min_purchase:
        this.state.minPrice && this.state.freeByPrice
          ? this.state.minPrice
          : null,
      free_min_count:
        this.state.minCount && this.state.freeByCount
          ? this.state.minCount
          : null,
      all_city: this.state.cityInput === "all" ? true : false,
      shop_city: this.state.shopCity,
      cities: new_cities,
      active: this.state.active,
      index: this.state.index,
      provider: this.state.selectedProvider,
    };
    apiService(
      `v1/shops/${this.state.shopUid}/shipping-configs/${this.state.methodUid}`,
      "put",
      params
    ).then((data) => {
      if (data) {
        this.setState({ redirect: true });
      }
      this.setState({ pending: false });
    });
  }
  render() {
    return (
      <div className="container-fluid">
        {this.state.redirect && (
          <Redirect to={`/dashboard/${this.state.shopUid}/posting-methods`} />
        )}
        <SimpleHeader
          text={
            this.state.type === "add"
              ? "افزودن شیوه ارسال"
              : "ویرایش شیوه ارسال"
          }
        />
        <section style={{ marginTop: "80px", marginBottom: "20px" }}>
          <div className="row mx-0">
            <div className="col-12 px-0 fw-bold">
              <span>اطلاعات</span>
            </div>
            <div className="col-12 px-0 mt-3 position-relative">
              <select
                onChange={(e) =>
                  this.setState({ selectedProvider: e.target.value })
                }
                placeholder="روش"
                class="form-select select-dropdown-none text-end bg-none p-3 fw-bold w-100 rounded14"
              >
                {this.state.providers &&
                  this.state.providers.map((provider, p) => (
                    <option
                      className="text-end"
                      selected={provider.uid === this.state.selectedProvider}
                      value={provider.uid}
                    >
                      {provider.title}
                    </option>
                  ))}
              </select>
              <span
                className="position-absolute fs-7 color-main bg-white px-2"
                style={{ top: "-8px", right: "20px" }}
              >
                روش
              </span>
              <FiChevronDown
                className="position-absolute my-auto"
                style={{ left: "20px", top: "0", bottom: "0" }}
              />
            </div>
            <div className="col-12 px-0 mt-3 position-relative">
              <input
                className="form-control p-3 rounded14 fw-bold"
                placeholder="نام (به فارسی)"
                value={this.state.name}
                onChange={(e) => {
                  /^[آ-ی ]*$/.test(e.target.value) &&
                    this.setState({ name: e.target.value });
                }}
              />
              {this.state.name && (
                <span
                  className="position-absolute fs-7 color-main bg-white px-2"
                  style={{ top: "-8px", right: "20px" }}
                >
                  نام (به فارسی)
                </span>
              )}
            </div>
            <div className="col-12 px-0 mt-3 position-relative">
              <select
                onChange={(e) => this.setState({ index: e.target.value })}
                class="form-select select-dropdown-none text-end rounded14 fw-bold p-3 w-100"
              >
                {this.props.location &&
                  this.props.location.state &&
                  this.props.location.state.methods &&
                  this.props.location.state.methods.map((method, c) => (
                    <option
                      className="text-end"
                      selected={c + 1 === this.state.index}
                      value={c + 1}
                    >
                      {c + 1}
                    </option>
                  ))}
                {this.props.location.state &&
                  this.props.location.state.methods &&
                  !this.state.connectionId && (
                    <option
                      className="text-end"
                      selected={
                        this.props.location.state.methods.length + 1 ===
                        this.state.index
                      }
                      value={this.props.location.state.methods.length + 1}
                    >
                      {this.props.location.state.methods.length + 1}
                    </option>
                  )}
              </select>
              <span
                className="position-absolute fs-7 color-main bg-white px-2"
                style={{ top: "-8px", right: "20px" }}
              >
                ترتیب نمایش به کاربر
              </span>
              <FiChevronDown
                className="position-absolute my-auto"
                style={{ left: "20px", top: "0", bottom: "0" }}
              />
            </div>
            <div className="col-12 px-0 mt-3 position-relative">
              <textarea
                rows="2"
                className="form-control p-3 rounded14 fw-bold"
                placeholder="توضیح (به صورت خلاصه)"
                value={this.state.des}
                onChange={(e) => {
                  /^[آ-ی ]*$/.test(e.target.value) &&
                    this.setState({ des: e.target.value });
                }}
              />
              {this.state.des && (
                <span
                  className="position-absolute fs-7 color-main bg-white px-2"
                  style={{ top: "-8px", right: "20px" }}
                >
                  توضیح (به صورت خلاصه)
                </span>
              )}
            </div>
          </div>
          <div className="row mx-0 mt-4">
            <div className="col-12 px-0 fw-bold mb-3">
              <span>شهرهای تحت پوشش این طرح</span>
            </div>
            <div
              className="col-12 p-3 rounded14 border"
              onClick={() => this.setState({ cityInput: "all" })}
            >
              <input
                class="form-check-input mt-0 ms-3 align-middle color-second d-inline-block"
                type="radio"
                name="cityRadio"
                checked={this.state.cityInput === "all"}
                value={"all"}
              />
              <span>ارسال به سراسر ایران</span>
            </div>
            <div
              className="col-12 mt-3 p-3 rounded14 border"
              onClick={() => this.setState({ cityInput: "one" })}
            >
              <input
                class="form-check-input mt-0 ms-3 align-middle color-second d-inline-block"
                type="radio"
                name="cityRadio"
                checked={this.state.cityInput === "one"}
                value={"one"}
              />
              <span>شهرهای انتخابی</span>
            </div>
          </div>
          {this.state.cityInput === "one" && (
            <div className="row mx-0 mt-2">
              <div className="col-12 px-0 fw-bold mb-3">
                <span>شهرها</span>
              </div>
              {this.state.cities &&
                this.state.cities.map((city, c) => (
                  <div
                    className="col-auto border rounded28 px-3 py-2 small ms-2 mb-2"
                    key={c}
                    onClick={() => {
                      let old_cities = this.state.cities;
                      old_cities.splice(c, 1);
                      this.setState({ cities: old_cities });
                    }}
                  >
                    <span>{city.name}</span>
                    <MdClose className="color-second me-1" size={18} />
                  </div>
                ))}
              {this.state.shop &&
                this.state.shop.city &&
                this.state.cities &&
                this.state.cities.filter(
                  (item) => item.uid === this.state.shop.city.uid
                ).length === 0 && (
                  <div
                    onClick={() => {
                      let old_cities = this.state.cities;
                      old_cities.push(this.state.shop.city);
                      this.setState({ cities: old_cities });
                    }}
                    className="col-auto rounded28 px-3 py-2 mb-2 ms-1 bg-light-green small fw-bold color-main"
                  >
                    <FiPlus className="ms-2" size={18} />
                    افزودن {this.state.shop.city.name}
                  </div>
                )}
              <div
                onClick={() => this.setState({ geoModal: true })}
                className="col-auto border rounded28 px-3 py-2 mb-2 small fw-bold color-main"
              >
                افزودن شهر
              </div>
              {this.state.geoModal && (
                <CityModal
                  geoModal={this.state.geoModal}
                  changeModal={(e) => this.setState({ geoModal: e })}
                  selectedCities={this.state.cities}
                  setCity={(e) => {
                    let old_cities = this.state.cities;
                    old_cities.push(e);
                    this.setState({ cities: old_cities });
                  }}
                />
              )}
            </div>
          )}
          <div className="row mx-0 mt-4">
            <div className="col-12 px-0 fw-bold mb-3">
              <span>هزینه ارسال</span>
            </div>
            <div
              className="col-12 py-1"
              onClick={() => this.setState({ priceInput: "1" })}
            >
              <input
                class="form-check-input mt-0 ms-3 align-middle color-second d-inline-block"
                type="radio"
                name="priceRadio"
                checked={this.state.priceInput === "1"}
                value={"1"}
              />
              <span>مبلغ ثابت</span>
            </div>
            {this.state.priceInput === "1" && (
              <div className="col-12 mt-2 p-0 position-relative">
                <NumberFormat
                  dir={this.state.price ? "ltr" : "trl"}
                  thousandSeparator
                  value={this.state.price}
                  onBlur={(e) =>
                    e.target.value.replace(/,/gi, "") < 1000
                      ? e.target.classList.add("text-danger")
                      : e.target.classList.remove("text-danger")
                  }
                  onValueChange={(values) => {
                    this.setState({ price: values.value });
                  }}
                  className="form-control p-3 rounded14"
                  placeholder="هزینه ارسال(تومان)*"
                />
                {this.state.price ? (
                  <span
                    className="position-absolute fs-7 color-main bg-white px-2"
                    style={{ top: "-8px", right: "20px" }}
                  >
                    هزینه ارسال(تومان)*
                  </span>
                ) : (
                  ""
                )}
              </div>
            )}
            <div
              className="col-12 py-3"
              onClick={() => this.setState({ priceInput: "2", price: null })}
            >
              <input
                class="form-check-input mt-0 ms-3 align-middle color-second d-inline-block"
                type="radio"
                name="priceRadio"
                checked={this.state.priceInput === "2"}
                value={"2"}
              />
              <span>براساس قیمت شرکت هنگام ارسال</span>
            </div>
            <div
              className="col-12 mt-2 pb-3"
              onClick={() => this.setState({ priceInput: "3", price: 0 })}
            >
              <input
                class="form-check-input mt-0 ms-3 align-middle color-second d-inline-block"
                type="radio"
                name="priceRadio"
                checked={this.state.priceInput === "3"}
                value={"3"}
              />
              <span>کاملا رایگان</span>
            </div>
          </div>
          <div className="row mx-0 mt-4">
            <div className="col-12 px-0 fw-bold mb-3">
              <span>شرایط ارسال رایگان</span>
            </div>
            <div className="row mx-0 py-2 px-0">
              <div
                className="col ps-3 align-self-center"
                onClick={() =>
                  this.setState({
                    freeByPrice: !this.state.freeByPrice,
                  })
                }
              >
                <input
                  className="form-check-input"
                  value={this.state.freeByPrice}
                  checked={this.state.freeByPrice}
                  type="checkbox"
                />
                <span className="fw-bold me-3 align-self-center">
                  براساس مبلغ سفارش
                </span>
              </div>

              <div
                className="col-auto px-0 align-self-center"
                onClick={() => this.setState({ minPriceModal: true })}
              >
                <span className="text-muted fs-7">
                  {this.state.minPrice
                    ? moneyFormat(this.state.minPrice)
                    : "انتخاب نشده"}
                </span>
                <MdChevronLeft size={24} />
              </div>
              {this.state.minPriceModal && (
                <MinPriceModal
                  minPriceModal={this.state.minPriceModal}
                  changeModal={(e) => this.setState({ minPriceModal: e })}
                  setPrice={(e) => this.setState({ minPrice: e })}
                />
              )}
            </div>
            <div className="row mx-0 py-2 px-0 mt-3">
              <div
                className="col ps-3 align-self-center"
                onClick={() =>
                  this.setState({
                    freeByCount: !this.state.freeByCount,
                  })
                }
              >
                <input
                  className="form-check-input"
                  value={this.state.freeByCount}
                  checked={this.state.freeByCount}
                  type="checkbox"
                />
                <span className="fw-bold me-3 align-self-center">
                  براساس تعداد اقلام سفارش
                </span>
              </div>

              <div
                className="col-auto px-0 align-self-center"
                onClick={() => this.setState({ minCountModal: true })}
              >
                <span className="text-muted fs-7">
                  {this.state.minCount ? (
                    <span>
                      <HiPlus size="12" className="text-secondary" />
                      {this.state.minCount + " کالا "}
                    </span>
                  ) : (
                    "انتخاب نشده"
                  )}
                </span>
                <MdChevronLeft size={24} />
              </div>
              {this.state.minCountModal && (
                <MinCountModal
                  minCountModal={this.state.minCountModal}
                  changeModal={(e) => this.setState({ minCountModal: e })}
                  setCount={(e) => this.setState({ minCount: e })}
                />
              )}
            </div>
          </div>
          <div className="row mx-0 px-0 mt-4">
            <div className="col-12 px-0">
              <button
                disabled={
                  this.state.pending ||
                  !this.state.name ||
                  !this.state.des ||
                  !this.state.selectedProvider ||
                  (this.state.priceInput === "1" && this.state.price < 1000)
                }
                onClick={() =>
                  this.state.type === "add"
                    ? this.addMethod()
                    : this.editMethod()
                }
                className="btn bg-disabled w-100 rounded28 py-2-3 text-center bg-color-main text-white fw-bold fs-6"
              >
                {this.state.pending ? (
                  <span className="spinner-border spinner-border-sm text-white align-middle"></span>
                ) : this.state.type === "add" ? (
                  "ثبت"
                ) : (
                  "ویرایش"
                )}
              </button>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default PostingMethodDetail;
